import React from 'react';
import House from '../components/House';

const FilteredProperties = ({ currentHouses }) => {
  const numHouses = currentHouses.length;
  const rows = [];
  for (let i = 0; i < numHouses; i += 2) {
    rows.push(i);
  }

  return (
    <div className="projects">
      {/* Primul rând (3 elemente) */}
      {currentHouses.length > 0 && (
        <div className="row" id='first_row'>
          <div className="col sm first-two-cols"> {/* Adăugăm clasa first-two-cols */}
            {currentHouses[0] && <House house={currentHouses[0]} />}
          </div>
          {currentHouses.length > 1 && (
            <div className="col sm first-two-cols"> {/* Adăugăm clasa first-two-cols */}
              {currentHouses[1] && <House house={currentHouses[1]} />}
            </div>
          )}
          {currentHouses.length > 2 && (
            <div className="col sm">
              {currentHouses[2] && <House house={currentHouses[2]} />}
            </div>
          )}
        </div>
      )}
      {/* Al doilea rând (2 elemente cu lățimi și înălțimi identice) */}
      {currentHouses.length > 3 && (
        <div className="row">
          <div className="col sm">
            {currentHouses[3] && <House house={currentHouses[3]} />}
          </div>
          {currentHouses.length > 4 && (
            <div className="col sm">
              {currentHouses[4] && <House house={currentHouses[4]} />}
            </div>
          )}
        </div>
      )}

      {/* Al treilea rând (3 elemente precum primul rând, dar inversat) */}
      {currentHouses.length > 5 && (
        <div className="row" style={{ flexDirection: 'row-reverse' }}>
          <div className="col sm">
            {currentHouses[5] && <House house={currentHouses[5]} />}
          </div>
          {currentHouses.length > 6 && (
            <div className="col sm">
              {currentHouses[6] && <House house={currentHouses[6]} />}
            </div>
          )}
          {currentHouses.length > 7 && (
            <div className="col sm">
              {currentHouses[7] && <House house={currentHouses[7]} />}
            </div>
          )}
        </div>
      )}

      {/* Al patrulea rând (2 elemente precum al doilea rând) */}
      {currentHouses.length > 8 && (
        <div className="row">
          <div className="col sm">
            {currentHouses[8] && <House house={currentHouses[8]} />}
          </div>
          {currentHouses.length > 9 && (
            <div className="col sm">
              {currentHouses[9] && <House house={currentHouses[9]} />}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FilteredProperties;